<div style="padding: .5rem .75rem;border-radius: 8px;background: #8b8b8b4f;border: dashed;">
  <div kendoTypography variant="p">
    <i>Note: Marketing Sheet cutters are automatically calculated from the model. Please verify numbers are
      accurate before proceeding. Once verified, please </i>
    <button kendoButton themeColor="success" (click)="saveMarketingSheet()">Save Marketing Sheet</button>
  </div>
</div>
<div>
  <form [formGroup]="form">
    <div class="cutters-grid">
      <div class="grid-cell empty"></div>

      <div class="grid-cell header" *ngFor="let size of cutterSizes">
        {{ size }}
      </div>

      <div class="grid-cell row-label">(Face)</div>
      <div class="grid-cell" *ngFor="let size of cutterSizes">
        <kendo-numerictextbox [formControlName]="'face' + size" [format]="'n0'" [decimals]="0" [min]="0"
          [spinners]="false" class="input-box">
        </kendo-numerictextbox>
      </div>

      <div class="grid-cell row-label">(Gauge)</div>
      <div class="grid-cell" *ngFor="let size of cutterSizes">
        <kendo-numerictextbox [formControlName]="'gauge' + size" [format]="'n0'" [decimals]="0" [min]="0"
          [spinners]="false" class="input-box">
        </kendo-numerictextbox>
      </div>
    </div>
  </form>
<marketing-sheet-photos
    [materialNumber]="materialNumber"
    [subPslName]="subPsl.name.replace(' ', '')">
  </marketing-sheet-photos>
</div>
<app-bitfeature-data [draftId]="draftId" [preselectedIds]="bitFeatureIds" [readonly]="false">
</app-bitfeature-data>
